import React, { Component } from 'react';
import { connect } from "react-redux";
import { getDashboardApi } from "./Api";
import { ComponentHeader } from '../common';
import { Col, Row, Spinner } from 'react-bootstrap';
import { withRouter } from '../../utils/hoc/withRouter';
import { getAdminUser } from '../../utils/ReusableFunctions';
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        this.props.getDashboardApi(this);
    }

    render() {
        const { dashboardList, totalPages, currentPage } = this.props.dashboardState;
        const admin = JSON.parse(localStorage.getItem("finAdmin"))?.user || {};
        if(admin.ssoPartner?.type !== 'ssoPartner'){
            return null
        }
        return (
            <section>
                <ComponentHeader
                    isSearch={false}
                    breadcrumb={[[`${getAdminUser()?.ssoPartner?.companyName} Dashboard`,"/dashboard"]]}
                />
                <div className="dashboard-content-section">
                    <Row>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Registered User Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.registeredUserCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Premium User Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.premiumUserCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Content Cobrand Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.contentCobrandCount?.count || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Amc Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.amcCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Content Download Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.contentDownloadCount?.count || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Non-Premium User Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.nonPremiumUserCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Targeted Content Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.targetedContentCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Language Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.languageCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>
                        <Col sm={4} className='mb-5'>
                            <div className="dash-title">
                                <h5 className=' f-s-16 inter-medium lh-21'>Campaign Count </h5>
                                <p className='f-s-16 inter-regular lh-21'>{dashboardList?.campaignCount || <Spinner animation="grow" />}</p>
                            </div>
                        </Col>


                    </Row>

                    <h3 className='inter-regular f-s-24 lh-29 mb-5 '>Content Types :-</h3>
                    <Row>
                        {Object.keys(dashboardList?.contentCountWithContentName || {}).map((item) => {
                            return (
                                <Col sm={4} className='mb-5'>
                                    <div className="dash-title">
                                        <h5 className=' f-s-16 inter-medium lh-21'>{item} </h5>
                                        <p className='f-s-16 inter-regular lh-21'>{dashboardList?.contentCountWithContentName[item] || <Spinner animation="grow" />}</p>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>

                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    dashboardState: state.DashboardState
});
const mapDispatchToProps = {
    getDashboardApi
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));